
export const clamp = (num: number, min: number, max: number) =>
  Math.min(Math.max(num, min), max)

export const formatNumber = (number: number | string) => {
  return +number > 10_000
    ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
    : number
}

